import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as modalDialog from "modalDialog";
import * as mustcache from "mustcache";

/* arguments
 * ---------
 *
 * @param {SelectionModel}      model
 * @param {SelectionActionList} selectionActionList
 */
const SelectionActionView = Backbone.View.extend({
  tagName: "select",
  events: {
    "click .dropdownButton": "clickDropdown",
  },
  initialize: function (options) {
    this.options = options || {};

    _.defaults(this.options, {
      name: "Actions",
    });

    this.selectionActionList = options.selectionActionList;

    this.$listElement = this.$el.find(".dropdownButtonList");
    this.listenTo(this.model, "change:count", () => {
      this.updateState();
    });
    this.render();
  },
  render: function () {
    const that = this;

    this.$el.html(
      mustcache.render("selectionActions", {
        name: this.options.name,
        heading: this.options.heading,
        actions: this.selectionActionList.toJSON(),
      })
    );

    if (this.options.width) {
      this.$(".dropdownButtonList").css("width", this.options.width);
    }

    // can't use delegate events for this since it goes into a modal
    this.$el
      .find(".selectOption")
      .off()
      .click((event) => {
        that.clickAction(event);
      });
    this.delegateEvents();
  },
  clickAction: function (event) {
    const actionID = $(event.target).attr("data-action");

    modalDialog.cancel();

    const action = this.selectionActionList.get(actionID);

    if (action.has("exec")) {
      action.get("exec")();
    } else {
      this.model.performAction(action);
    }
  },
  clickDropdown: function () {
    modalDialog.show(this.$el.find(".dropdownButtonList"), {
      center: false,
      addToBody: true,
    });
  },
  updateState: function () {
    this.$el
      .find(".dropdownButton")
      .prop("disabled", this.model.get("count") === 0);

    let readyToShowSplitter = false;
    let $splitterToShow;

    this.selectionActionList.each((action) => {
      const $listItem = this.$('li[data-action="' + action.id + '"]');
      $listItem.text(
        this.model.get("itemIDs").length === 1
          ? action.get("name")
          : action.get("namePlural")
      );

      if (action.get("splitter")) {
        $listItem.hide();
        if (readyToShowSplitter) {
          $splitterToShow = $listItem;
          readyToShowSplitter = false;
        }
      } else if (
        action.appliesToSelection(this.model, {
          itemIDsOnly: this.options.itemIDsOnly,
        })
      ) {
        if ($splitterToShow) {
          $splitterToShow.show();
          $splitterToShow = undefined;
        }
        $listItem.show();
        readyToShowSplitter = true;
      } else {
        $listItem.hide();
      }
    });
  },
});

export default SelectionActionView;
